import { setChatListSyncFailed, setChatListSyncPending, setChatListSyncSucceed } from './actions';
import { getChatsV2 } from './getChatsV2';
import { DEFAULT_SYNC_PAGE_SIZE } from '../../constants/syncPageSize';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { syncChatsV2 } from '../../services/chatsList/syncChatsV2';
import { EHostType } from '../../types/hostType';
import { TThunkAction } from '../../types/redux/thunk';
import { ERequestTrigger } from '../../types/requestTrigger';
import { getPageStateLogData } from '../../utils/getPageStateLogData';
import { getQueryParamsFetchChatsList } from '../../utils/getQueryParamsFetchChatsList';
import { getSyncPagesByChats } from '../../utils/getSyncPagesByChats';

/**
 * Синхронизировать чаты чанками
 */
export const synchronizeChatsV2 =
  (trigger?: ERequestTrigger): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      hostType,
      chatList,
      masterFilters: { selectedSubAgentId },
    } = state;

    // TODO убрать после фикса на беке
    if (hostType === EHostType.Frame) {
      return;
    }

    const { currentRoute, chats } = chatList;

    const { status, filterBy } = getQueryParamsFetchChatsList(currentRoute);

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setChatListSyncPending());

    const commonProps = {
      subAgentRealtyUserId,
      status,
      filterBy,
    };

    const syncPageSize = context.config.get<number>('frontend-chats.syncPageSize') || DEFAULT_SYNC_PAGE_SIZE;
    const syncPages = getSyncPagesByChats({ chatsCount: chats.length, syncPageSize });

    const pagesForSyncParameters = Array.from({ length: syncPages }).map((_, index) => {
      const startIndex = index * syncPageSize;
      const chatListChunk = chats.slice(startIndex, startIndex + syncPageSize);

      const lastChatAtChunk = chatListChunk[chatListChunk.length - 1];
      const lastChatAtPreviousChunk = index ? chats[startIndex - 1] : undefined;

      return {
        ...commonProps,
        chatIds: chatListChunk.map(chat => chat.chatId),
        minDatetimeForSorting: new Date(lastChatAtChunk.updated).toISOString(),
        maxDatetimeForSorting: lastChatAtPreviousChunk
          ? new Date(lastChatAtPreviousChunk.updated).toISOString()
          : undefined,
      };
    });

    const chunksSyncResponses = await Promise.all(
      pagesForSyncParameters.map(parameters =>
        syncChatsV2(context, {
          parameters,
          logData: getPageStateLogData(state, trigger),
        }),
      ),
    );

    const syncErrors = chunksSyncResponses.map(response => response.error).filter(Boolean) as string[];

    if (!syncErrors.length) {
      dispatch(setChatListSyncSucceed(chunksSyncResponses.flatMap(response => response.chats || [])));

      return;
    }

    if (syncErrors.includes('tooManyRecords')) {
      dispatch(getChatsV2({ mergeResult: false, trigger: ERequestTrigger.ChatListSyncTooManyRecords }));

      return;
    }

    dispatch(setChatListSyncFailed());
  };
